import React, { Component } from 'react';
import ProjectsEditLayout from '../../templates/projects';
import ProjectCommission from '../../elements/projects/commissions';
import Loading from "../../elements/loading";

class ProjectEdit extends Component {
	render (){
		const {projects} = this.props;
		return (
			projects.isFetching ? <Loading message="Cargando..." /> : <ProjectCommission {...this.props}/>
		);
	}

	componentWillMount() {
		this.props.fetchProjectCommission(this.props.match.params.id);
	}
}

export default ProjectsEditLayout(ProjectEdit, {subnav: 5});



// WEBPACK FOOTER //
// ./src/layouts/projects/commissions.jsx